// material-ui
import { Box, Stack } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
// project import
import MainCard, { MainCardProps } from 'views/components/cards/MainCard';
import LocalizationSection from '../MainLayout/Header/LocalizationSection';

// style constant
const useStyles = makeStyles((theme: Theme) => ({
  card: {
    maxWidth: '520px',
    '& > *': {
      flexGrow: 1,
      flexBasis: '50%'
    },
    [theme.breakpoints.down('sm')]: {
      margin: '20px'
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '400px'
    }
  },
  contentClass: {
    padding: 0
  },
  content: {
    padding: `${theme.spacing(5)} !important`,
    paddingTop: `${theme.spacing(2)} !important`,
    [theme.breakpoints.down('lg')]: {
      padding: `${theme.spacing(3)} !important`,
      paddingTop: `${theme.spacing(3)} !important`
    }
  }
}));

// ==============================|| AUTHENTICATION CARD WRAPPER ||============================== //

const AuthCardWrapper = ({ children, ...other }: MainCardProps) => {
  const classes = useStyles();

  return (
    <MainCard className={classes.card} contentClass={classes.contentClass} {...other}>
      <Stack sx={{ justifyContent: 'flex-end', alignItems: 'flex-end', pt: 4 }}>
        <LocalizationSection />
      </Stack>

      <Box className={classes.content}>{children}</Box>
    </MainCard>
  );
};

export default AuthCardWrapper;
